import OutputIndicatorsPanel from './OutputIndicatorsPanel';

export default OutputIndicatorsPanel;
